import React from 'react';
import { Grid, Box } from '@mui/material';
import TransformationBase from './common/TransformationBase';
import { TransformationHeading } from './common/fields/Heading';
import { COMMON_STYLES, COMMON_VALIDATION } from './common/Constants';
import { SourceColumnField } from './common/fields/SourceColumnField';
import { OutputColumnField } from './common/fields/OutputColumnField';
import { CheckBoxField } from './common/fields/CheckBoxField';
import TransformationArrayField from './common/fields/TransformationArrayField';

const INITIALSTATE = {
  type: 'abs',
  alias: '',
  df: '',
  transformations: [
    {
      sourceColumns: [''],
      outputColumn: '',
      transformInPlace: false,
    },
  ],
};

const renderTransformationFields = ({ formField, errors, setFieldValue, disableForm, headers }) => {
  const handleInPlaceChange = (index, value) => {
    const newTransforms = [...formField.transformations];
    newTransforms[index].transformInPlace = value;
    if (value) {
      newTransforms[index].outputColumn = '';
    }
    setFieldValue('transformations', newTransforms);
  };

  const renderField = ({ transform, index, headers, disableForm, errors }) => {
    return (
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <CheckBoxField
            checked={transform.transformInPlace}
            onChange={(value) => handleInPlaceChange(index, value)}
            disabled={disableForm}
          />
        </Grid>
        <Grid item {...COMMON_STYLES.gridItem}>
          <SourceColumnField
            value={transform.sourceColumns[0] || ''}
            onChange={(e) => {
              const newTransforms = [...formField.transformations];
              newTransforms[index].sourceColumns = [e.target.value];
              setFieldValue('transformations', newTransforms);
            }}
            headers={headers}
            disabled={disableForm}
            error={!!errors?.sourceColumns}
            helperText={
              errors?.sourceColumns ||
              (transform.transformInPlace
                ? 'This column will be modified directly'
                : 'Select numeric column to transform')
            }
          />
        </Grid>
        {!transform.transformInPlace && (
          <Grid item {...COMMON_STYLES.gridItem}>
            <OutputColumnField
              value={transform.outputColumn || ''}
              onChange={(e) => {
                const newTransforms = [...formField.transformations];
                newTransforms[index].outputColumn = e.target.value;
                setFieldValue('transformations', newTransforms);
              }}
              disabled={disableForm}
              error={!!errors?.outputColumn}
              helperText={errors?.outputColumn || 'Enter output column name'}
            />
          </Grid>
        )}
      </Grid>
    );
  };
  return (
    <Box sx={COMMON_STYLES.container}>
      <TransformationHeading title="Absolute - Convert to positive value (-5 → 5)" disabled={disableForm} />
      <TransformationArrayField
        transformations={formField.transformations}
        setTransformations={(newTransforms) => setFieldValue('transformations', newTransforms)}
        renderField={renderField}
        errors={errors.transformations || []}
        headers={headers}
        disableForm={disableForm}
      />
    </Box>
  );
};

const NodeModal_Abs = (props) => (
  <TransformationBase
    {...props}
    INITIALSTATE={INITIALSTATE}
    validationSchema={COMMON_VALIDATION}
    renderTransformationFields={renderTransformationFields}
    transformationType={INITIALSTATE.type}
    tranformationName="Absolute"
  />
);

export default NodeModal_Abs;